import React from 'react';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import {
  FDDialog,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

const dialogMetaOverrideSet = buildFacetDesignOverride()
  .overrideAll({
    _customProps: {
      fullWidth: true,
    },
  }, overrideReadOnly)
// This is a workaround for the year/month date selectors. We override dates with hint 'yearMonth' with a
// customProp 'inputFormat' in buildFacetDesignOverride, but when we apply the fullWidth prop in the overrideAll it
// blows away the 'inputFormat' so we need to put it back here.
  .override({ hint: 'yearMonth' }, { _customProps: { inputFormat: 'MM/YYYY', fullWidth: true } }, overrideReadOnly);

function ExpenseDialog({
  resource,
  onCancel,
  onSubmit,
  onDelete,
  metaLayout,
}) {
  const isEdit = !!resource.link('self');

  return (
    <FDDialog open onClose={onCancel}>
      <MetaFormInline
        layout={metaLayout}
        LayoutProps={{
          onCancel,
          isEdit,
          resource,
        }}
        onSubmit={onSubmit}
        onDelete={onDelete}
        resource={resource}
        noIndividualSubmitButtons
        noIndividualDeleteButtons
        metaOverrideSet={dialogMetaOverrideSet}
        confirmDeleteMessage={onDelete ? 'This will permanently delete the expense' : undefined}
      />
    </FDDialog>
  );
}
ExpenseDialog.defaultProps = {
  resource: null,
  onDelete: undefined,
};
ExpenseDialog.propTypes = {
  resource: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  metaLayout: PropTypes.func.isRequired,
};

export { ExpenseDialog };
